import React from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import styles from './JobTestSticky.module.scss'
import replaceText from '../../../../common/utils/replaceText'

export const ShowGatsbyImage = ({
  alt,
  image,
  width,
  height,
  className,
  tokens,
}) => {
  return (
    <GatsbyImage
      loading="lazy"
      alt={replaceText(tokens, alt)}
      className={`${className} w-100`}
      image={image}
      objectFit="contain"
      style={{ width, height }}
    />
  )
}

const JobTestSticky = ({ buyLink, freeLink, tokens }) => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { extension: { regex: "/(jpg)|(png)|(jpeg)/" } }) {
        edges {
          node {
            base
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `)

  const imageMap = {}
  data?.allFile?.edges?.forEach((img) => {
    imageMap[img.node.base] = img.node.childImageSharp.gatsbyImageData
  })

  return (
    <div
      style={{ background: '#525254 !important' }}
      className={` ${styles.jobPrepBg} ${styles.main}`}
    >
      <div className="">
        <div className={styles.inner}>
          <div className={`${styles.stickyTop} d-flex w-100`}>
            <div>
              <ShowGatsbyImage
                alt="jobtestprep-mobiletop"
                image={getImage(imageMap['jobtestprep-mobiletop.jpg'])}
              />
            </div>
          </div>
          <div className={`${styles.sticky} d-flex w-100`}>
            <div className={styles.scaleImage}>
              <ShowGatsbyImage
                alt="jobtestprep-scaled-img"
                image={getImage(imageMap['jobtestprep-scaled-img.jpeg'])}
                width="100%"
                height={102}
              />
            </div>
            <div>
              <a href={buyLink} target="_blank" rel="noreferrer">
                <ShowGatsbyImage
                  alt="jobtestprep-buy"
                  image={getImage(imageMap['jobtestprep-buy.jpeg'])}
                  width="100%"
                  height={102}
                />
              </a>
            </div>
            <div>
              <a href={buyLink} target="_blank" rel="noreferrer">
                <ShowGatsbyImage
                  alt="jobtestprep-free"
                  image={getImage(imageMap['jobtestprep-free.jpeg'])}
                  width="100%"
                  height={102}
                />
              </a>
            </div>
            <div>
              <ShowGatsbyImage
                alt="jobtestprep-scaled-img04"
                image={getImage(imageMap['jobtestprep-scaled-img04.jpeg'])}
                width="100%"
                height={102}
                tokens={tokens}
              />
            </div>
            <div>
              <img
                alt="jobtestprep-mobile"
                src="/jobtestprep-mobile.jpg"
                width="auto"
                height="auto"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default JobTestSticky
